import React, {useState} from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Csubscriber = ({channelData, setSubscriber, userData}) => {
      const [subList, setSubList] = useState(channelData.subscribers ?? []);
      const [fromDate, setFromDate] = useState('');
const [toDate, setToDate] = useState('');
      // const comValue = userData.exp_level;
const [showPaymentModal, setShowPaymentModal] = useState(false);
const [paymentId, setPaymentId] = useState('');
const [submitting, setSubmitting] = useState(false);
const navigate = useNavigate();


      
const filteredSubs = subList.filter(sub => {
  if (!fromDate && !toDate) return true;

  const buyDate = new Date(sub.buy_on);

  if (fromDate && new Date(fromDate) > buyDate) return false;
  if (toDate && new Date(toDate) < buyDate) return false;

  return true;
});

                      const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const totalRevenue = filteredSubs.reduce((sum, sub) => {
  return sum + (parseFloat(sub.com_amount) || 0);
}, 0);

// const adminCommission = (totalRevenue * comValue) / 100;


const totalPending = filteredSubs.reduce((sum, sub) => {
  if (sub.com_pay_status == "Pending") {
    return sum + (parseFloat(sub.com_amount) || 0);
  }
  return sum;
}, 0);


const totalSuccess = filteredSubs.reduce((sum, sub) => {
  if (sub.com_pay_status == "Success") {
    return sum + (parseFloat(sub.com_amount) || 0);
  }
  return sum;
}, 0);


const processWithdrawal = async () => {
  if (!paymentId.trim()) {
            toast.error('Please enter Payment ID');
    
    return;
  }


  setSubmitting(true);

  try {
    const response = await fetch(
      "https://api.tradeintell.com/process-withdrawal",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          channel_id: channelData.id,
          com_pay_id: paymentId,
        }),
      }
    );

    const data = await response.json();

    if (response.status == 200) {
      toast.success("Withdrawal processed successfully");
      setShowPaymentModal(false);
      setPaymentId('');
setSubscriber(false);
    } else {
      toast.error(data.message || "Something went wrong");
    }

  } catch (error) {
    alert("Server error");
  }

  setSubmitting(false);
};

  return (
    <>
    <div className='d-flex flex-wrap'>
    <p
  className={`px-3 py-1 mt-2 mb-1 align-content-center rounded-pill bg-secondary text-light cursor-pointer para-text`}
  onClick={() => setSubscriber(false)}
>
  Go Back
</p>

<input
  type="date"
  className="my-2 form-control para-text mx-2"
  style={{maxWidth:'180px'}}
  value={fromDate}
  onChange={(e)=>setFromDate(e.target.value)}
/>

<input
  type="date"
  className="my-2 form-control para-text"
  style={{maxWidth:'180px'}}
  value={toDate}
  onChange={(e)=>setToDate(e.target.value)}
/>
</div>

<div className='row mt-2'>

<div className='col-lg-3 col-md-6 col-12 my-2'>
<div className='subs-card'>
    <p className='fs-4'><span className='subs-num'>{subList.length}</span></p>
    <p className='mb-0 fw-semibold text-danger'>No of Subscribers</p>
 <span className='para-text text-muted fw-semibold'>Total</span>
 </div>
</div>

<div className='col-lg-3 col-md-6 col-12 my-2'>
<div className='subs-card'>
    <p className='fs-4'><span className='subs-num'>₹ {totalRevenue}</span></p>
    <p className='mb-0 fw-semibold text-primary'>Commission</p>
    <span className='para-text text-muted fw-semibold'>Channel Admin</span>
</div>
</div>


<div className='col-lg-3 col-md-6 col-12 my-2'>
<div className='subs-card'>
    <p className='fs-4'><span className='subs-num'>₹ {totalPending}</span></p>
    <p className='mb-0 fw-semibold text-info'>Withdrawal Requests</p>
      {totalPending > 0
      ?     <span  onClick={() => {
    if (totalPending > 0) {
      setShowPaymentModal(true);
    }
  }} className='para-text text-light rounded-2 cursor-pointer pb-1 fw-semibold bg-warning px-2'>Pay Now</span>

    :     <span className='para-text text-muted fw-semibold'>Pending</span>
}
</div>
</div>

<div className='col-lg-3 col-md-6 col-12 my-2'>
<div className='subs-card'>
    <p className='fs-4'><span className='subs-num'>₹ {totalSuccess}</span></p>
    <p className='mb-0 fw-semibold text-success'>Transfer Processed</p>
    <span className='para-text text-muted fw-semibold'>Success</span>
</div>
</div>

</div>
    {/* row ends */}

<div className='table-responsive mt-3'>
    <table className='table w-100 channel-table'>

        <thead className='channel-head'>
            <tr>
                <th>S No</th>
                <th>User Name</th>
                <th>Buy On</th>
                <th>Valid Till</th>
                <th>User Id</th>
                <th>Payment Id</th>
                <th>Pay Status</th>
                <th>Commission</th>
            </tr>
        </thead>

<tbody className='para-text'>
      {filteredSubs.length > 0 ? (
    filteredSubs.map((c, index) => (
      <tr key={c.id}>
        <td>{index + 1}</td>
        <td>{c.subscriber_name}</td>
        <td>{formatDate(c.buy_on)}</td>
        <td>{formatDate(c.end_on)}</td>
        <td>{c.user_tabId}</td>
        <td>{c.payment_id ?? '-'}</td>
        <td><span className={`rounded px-2 py-1 para-text text-light fw-semibold ${c.pay_status == 'Success' ? 'bg-success' : 'bg-danger'}`}>{c.pay_status}</span></td>
        <td><span className={`rounded px-2 py-1 para-text fw-semibold`}>{c.pay_status == 'Success' ? <>{formatDate(c.com_pay_on)}<br />Pay Id: {c.com_pay_id}</> : c.pay_status}</span></td>

      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="text-center">
        No Subscription History found.
      </td>
    </tr>
  )}
</tbody>
</table>
</div>

{showPaymentModal && (
          <section className='detail-dialog p-2' onClick={() => setShowPaymentModal(false)}>
            <div className='detail-dialog-inner col-lg-5 animate__animated animate__zoomIn rounded mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>

       <button className='float-end btn btn-outline-warning' onClick={() => setShowPaymentModal(false)}>Close</button>


    <p className="sidebar-menu-title text-dark fs-6 my-0">
     Complete Payment
    </p>
          <p className='para-text text-muted'>Pending Amount: ₹{totalPending}</p>


<p>UPI Id: {channelData.upi_id}</p>

        <div className="modal-body">

      

          <input
            type="text"
            className="form-control"
            placeholder="Enter Payment ID"
            value={paymentId}
            onChange={(e)=>setPaymentId(e.target.value)}
          />

        </div>


          <button
            className="btn btn-success mt-4"
            disabled={submitting}
            onClick={processWithdrawal}
          >
            {submitting ? "Processing..." : "Confirm"}
          </button>

    </div>
  </section>
)}

    </>
  )
}

export default Csubscriber